import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "../types";

export default function CityProcessingTimeSection({
  city,
  state,
  options,
  intro,
}: {
  city: string;
  state: string;
  options: ProcessingOption[];
  intro?: string;
}) {
  const emergencyOpt = options.find((o) => o.emergency);
  const emergencyDescription =
    emergencyOpt?.emergencyDescription ||
    `${city} does not have its own regional passport agency. The closest agencies require an appointment and travel. You must obtain an NPIC appointment in advance — no walk-ins permitted.`;

  const disclaimerText =
    "*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing.";

  const defaultIntro = `${city} travelers have several options. Here's how they compare — and why most choose a U.S. Department of State registered passport courier agency to handle their passport.`;

  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName={city}
      headingExtra={state}
      introText={intro || defaultIntro}
      options={options}
      emergencyDescription={emergencyDescription}
      disclaimerText={disclaimerText}
    />
  );
}